const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';
const FRONTEND_SECRET = process.env.REACT_APP_FRONTEND_SECRET || '';

function getAuthToken(): string | null {
  return localStorage.getItem('@sistema-up:token');
}

async function apiRequest(endpoint: string, options?: RequestInit): Promise<any> {
  const token = getAuthToken();
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    'X-Frontend-Secret': FRONTEND_SECRET,
  };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const response = await fetch(`${API_URL}${endpoint}`, {
    ...options,
    headers: { ...headers, ...options?.headers },
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Erro desconhecido' }));
    throw new Error(error.error || `HTTP ${response.status}`);
  }

  return response.json();
}

export interface SessaoAtiva {
  id: string;
  usuario_id: string;
  usuario_nome: string;
  usuario_login: string;
  filial_atual: string | null;
  ip_address: string | null;
  user_agent: string | null;
  data_login: string;
  ultima_atividade: string;
  status: 'ativa' | 'inativa';
}

class SessoesService {
  // Registrar sessão ao fazer login (via backend API - bypassa RLS)
  async registrarSessao(usuario: any, filialAtual?: string) {
    try {
      await apiRequest('/sessoes', {
        method: 'POST',
        body: JSON.stringify({ filial_atual: filialAtual || null })
      });
      return { success: true };
    } catch (error) {
      console.error('Erro ao registrar sessão:', error);
      return { success: false };
    }
  }

  // Remover sessão ao fazer logout
  async removerSessao(usuarioId: string) {
    try {
      await apiRequest('/sessoes', { method: 'DELETE' });
      return { success: true };
    } catch (error) {
      console.error('Erro ao remover sessão:', error);
      return { success: false };
    }
  }

  // Remover todas as sessões de um usuário
  async removerSessoesUsuario(usuarioId: string) {
    try {
      await apiRequest('/sessoes', { method: 'DELETE' });
      return { success: true };
    } catch (error) {
      console.error('Erro ao remover sessões do usuário:', error);
      return { success: false };
    }
  }

  // Atualizar última atividade (heartbeat)
  async atualizarAtividade(usuarioId: string, filialAtual?: string) {
    try {
      await apiRequest('/sessoes/atividade', {
        method: 'PUT',
        body: JSON.stringify({ filial_atual: filialAtual || null })
      });
      return { success: true };
    } catch (error) {
      console.error('Erro ao atualizar atividade:', error);
      return { success: false };
    }
  }

  // Buscar usuários online
  async buscarUsuariosOnline(): Promise<SessaoAtiva[]> {
    try {
      const result = await apiRequest('/monitoramento/sessoes');
      return result.data || [];
    } catch (error) {
      console.error('Erro ao buscar usuários online:', error);
      return [];
    }
  }

  // Limpar sessões inativas
  async limparSessoesInativas() {
    return { success: true };
  }

  // Verificar se usuário está online
  async isUsuarioOnline(usuarioId: string): Promise<boolean> {
    try {
      const usuarios = await this.buscarUsuariosOnline();
      return usuarios.some(u => u.usuario_id === usuarioId);
    } catch (error) {
      return false;
    }
  }
}

export default new SessoesService();
